import {VesselCall} from "~/queries";
import Grid from "@mui/material/Grid";
import {Button, Card, CardContent, Divider, Typography} from "@mui/material";
import {StatusBadge} from "~/apps/core/ui/StatusBadge";
import {getVesselCallStatusColor} from "~/apps/packages/vessel-calls/utils";
import {BorderedBox} from "~/apps/core/ui/BorderedBox";
import {Tag} from "~/apps/core/ui/Tag";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {formatDate} from "~/apps/core/utils";
import moment from "moment";
import React from "react";
import {OpenInNew, Star} from "@mui/icons-material";
import {VoyageCard} from "~/apps/packages/vessel-calls/components/VesselCallDetail/VoyageCard";
import {Box} from "@mui/system";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {VesselFavoriteButton} from "~/apps/packages/vessel-calls/components/VesselCallDetail/VesselFavoriteButton";

export type VesselCallDetailProps = {
    vesselCall: VesselCall
}

export const VesselCallDetail = (props: VesselCallDetailProps) => {
    const {vesselCall} = props;

    const tags = [...new Set([
        vesselCall.type, vesselCall.arrival.type, vesselCall.departure.type
    ].filter(Boolean))];

    const handleShorVesselInfoClick = () => {
        window.open(`https://www.marinetraffic.com/ru/ais/details/ships/imo:${vesselCall.vessel.imo}`, "_blank");
    }

    return (
        <Box>
            <Grid container direction="column" rowSpacing="16px" paddingY={2}>
                <Grid item>
                    <Card>
                        <CardContent>
                            <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
                                <Grid item container direction="column" rowSpacing="4px">
                                    <Grid container direction="row" justifyContent="space-between">
                                        <Grid item>
                                            <StatusBadge variant="cardText" outlined={false}
                                                         badgeColor={getVesselCallStatusColor(vesselCall.status)}>
                                                {vesselCall.status}
                                            </StatusBadge>
                                        </Grid>
                                        <Grid item>
                                            <Grid container alignItems="center" spacing="4px">
                                                {vesselCall.favorite && (
                                                    <Grid item>
                                                        <Star style={{color:"#E8B042", fontSize: "13px"}}/>
                                                    </Grid>
                                                )}
                                                {vesselCall.vessel.imo && (
                                                    <Grid item>
                                                        <BorderedBox variant="cardText">
                                                            <span>
                                                                IMO {vesselCall.vessel.imo}
                                                            </span>
                                                        </BorderedBox>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="cardTitle2" color="#232326">
                                            {vesselCall.vessel.name || <>&ndash;</>}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item container direction="row" spacing="8px">
                                    {tags.map(tag => (
                                        <Grid item key={tag}>
                                            <Tag>
                                                {tag}
                                            </Tag>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Grid item>
                                    <Divider/>
                                </Grid>
                                <Grid item container direction="row" columnSpacing="16px" rowSpacing="8px"
                                      flexWrap="wrap">
                                    <Grid item>
                                        <TypographyWithLabel label="Прибытие">
                                            {vesselCall.arrival.date ? (
                                                formatDate(moment(vesselCall.arrival.date, "YYYY-MM-DD"))
                                            ) : <>&ndash;</>}
                                        </TypographyWithLabel>
                                    </Grid>
                                    <Grid item>
                                        <TypographyWithLabel label="Убытие">
                                            {vesselCall.departure.date ? (
                                                formatDate(moment(vesselCall.departure.date, "YYYY-MM-DD"))
                                            ) : <>&ndash;</>}
                                        </TypographyWithLabel>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <TypographyWithLabel label="Позывной">
                                        {vesselCall.vessel.callSign || <>&ndash;</>}
                                    </TypographyWithLabel>
                                </Grid>
                                <Grid item>
                                    <TypographyWithLabel label="Длина, м">
                                        {vesselCall.vessel.length || <>&ndash;</>}
                                    </TypographyWithLabel>
                                </Grid>
                                {vesselCall.vessel.imo && (
                                    <Grid item>
                                        <Button onClick={handleShorVesselInfoClick}
                                                fullWidth
                                                color="additionalPrimary"
                                                size="forty"
                                                endIcon={<OpenInNew/>}
                                        >
                                            Информация о судне
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item>
                    <Typography variant="screenText" color="primary">
                        Входящий рейс
                    </Typography>
                </Grid>
                <Grid item>
                    <VoyageCard voyage={vesselCall.arrival}/>
                </Grid>
                <Grid item>
                    <Typography variant="screenText" color="primary">
                        Исходящий рейс
                    </Typography>
                </Grid>
                <Grid item>
                    <VoyageCard voyage={vesselCall.departure}/>
                </Grid>
            </Grid>
            {vesselCall.vessel?.imo && (
                <>
                    <Box height={80} minHeight={80}/>
                    <FloatingActions>
                        <VesselFavoriteButton imo={vesselCall.vessel?.imo} favorite={vesselCall.favorite} fullWidth/>
                    </FloatingActions>
                </>
            )}
        </Box>
    );
}